import * as React from 'react';
import { inject, observer } from 'mobx-react';
// import { inject } from '../utils';
import { DataStore, TranslationStore } from '../stores';

// TODO: Is it possible to inject translationStore as with the React component?
// export const translate = inject('translationStore')(({ translationStore }) => text => get(translationStore, text, text));

export const translate = (
    translationStore: TranslationStore,
    text: any,
    placeholders?: any
) => {
    return translationStore.translate(text, placeholders);
};

interface TranslationProps {
    dataStore?: DataStore;
    translationStore?: TranslationStore;
    // TODO: check whether this property is deprecated and can possibly be removed
    placeholders?: any;
}

// Component to get translated text from translation dictionary
// Children should be a string, but any other child types, e.g. a component, will simply pass through
@inject('translationStore', 'dataStore')
@observer
class Translate extends React.Component<TranslationProps, any> {
    render() {
        const {
            dataStore,
            translationStore,
            placeholders,
            children = null,
        } = this.props;
        if (
            dataStore &&
            dataStore.config &&
            dataStore.config.useHtmlTranslations
        ) {
            return (
                <span
                    dangerouslySetInnerHTML={{
                        __html: translate(
                            translationStore,
                            children,
                            placeholders
                        ),
                    }}
                />
            );
        }
        return translate(translationStore, children, placeholders);
    }
}

export default Translate;



// WEBPACK FOOTER //
// ./src/Components/Translate.tsx